import Vue from 'vue';
import Component from 'vue-class-component';
import { SECTION_TYPES, TYPE_BOARD_DRAFT_RESPONSE_OPTIONS, TYPE_TEXT_DRAFT_RESPONSE_OPTIONS } from '../values/sections';

@Component({})
export default class EdPresentationModeMixin extends Vue {

  get isWhiteboardTransparency() : boolean {
    return this.$store.state.MeetingsStore.isWhiteboardTransparency;
  }

  get currentPresentationSection() {
      return this.$store.state.MeetingsStore.currentPresentationSection.current;
  }

  get userId() : string {
      return this.$store.state.AuthStore.user.userId;
  }

  get currentBoardUserId() : number {
    return this.$store.state.MeetingsStore.currentBoardUser.id;
  }

  get currentBoardUser() : any {
    return this.$store.state.MeetingsStore.currentBoardUser;
  }

  get user() : any {
    return this.$store.state.AuthStore.user;
  }

  get userLoginId() : number {
    return this.$store.state.AuthStore.user.id;
  }

  get presentationSectionSelected() : any {
    return this.$store.state.HomeworksStore.presentationSectionSelected;
  }

  get presentationModeViewerType(): any {
    return this.$store.state.MeetingsStore.presentationModeViewerType;
  } 

  get isShareableTextSection(): boolean {
    return TYPE_TEXT_DRAFT_RESPONSE_OPTIONS.includes(this.presentationModeViewerType);
  }

  get canOpenWithCurrentVersion() : boolean {
    return this.isSectionSelectedDraftResponseOption
      || !this.presentationSectionSelected.responseDraft
      || !TYPE_BOARD_DRAFT_RESPONSE_OPTIONS.includes(this.presentationSectionSelected.section.type)
  }

  get isSectionSelectedDraftResponseOption(): boolean {
    return this.presentationSectionSelected.responseDraft && ((
      // Board
      TYPE_BOARD_DRAFT_RESPONSE_OPTIONS.includes(this.presentationSectionSelected.section.type)
      && this.presentationSectionSelected.responseDraft.type === SECTION_TYPES.LESSON_BOARD.code
    ) || (
        // Text
        TYPE_TEXT_DRAFT_RESPONSE_OPTIONS.includes(this.presentationSectionSelected.section.type)
    ));
  }

  get isPresentationNavigation() : boolean {
    return this.$store.state.MeetingsStore.isPresentationNavigation;
  }

  get zoomObject(): boolean {
    return this.$store.state.CourseStore.zoomObject;
  }

  sectionForCourse(courseId: number): any {
    if (!courseId) {
        return this.currentPresentationSection;
    }
    const courses = this.$store.state.MeetingsStore.currentPresentationSection.perCourse;
    const find = courses.find(entry => entry.courseId === courseId);
    return find;
  }
}
